// Group lifecycle status -> dashboard copy + colour tone.
//
// "registered" is an INTERIM state: the group has been submitted but its
// AML/PEP and National ID/Tax verifications are still pending. Rendering it as
// "Registered" in a green (positive) pill read as already-approved, so
// operators assumed the compliance checks were complete when they were not. It
// is relabelled "Pending Verification" and shown in a neutral tone.
// "Endorsed" stays reserved for groups that have actually cleared compliance.
// (BUG-11)

const STATUS_COPY = {
  pending_registration: 'Pending Registration',
  registered: 'Pending Verification',
  endorsed: 'Endorsed'
}

// Statuses that genuinely represent a cleared/positive outcome. Note
// "registered" is deliberately absent — it is a pre-compliance state.
const POSITIVE = ['endorsed', 'active', 'verified', 'passed', 'complete']
const NEGATIVE = ['suspended', 'cancelled', 'rejected', 'failed']

function normalise(status) {
  return status ? String(status).toLowerCase() : ''
}

// Title-cases an unmapped status the same way the old pills did, so any status
// the backend adds later still renders reasonably without a code change.
function humaniseStatus(status) {
  return String(status)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, function(c) {
      return c.toUpperCase()
    })
}

export function groupStatusLabel(status) {
  const key = normalise(status)
  if (STATUS_COPY[key]) {
    return STATUS_COPY[key]
  }
  if (!status) {
    return 'Unknown'
  }
  return humaniseStatus(status)
}

// Returns 'positive' | 'negative' | 'neutral' so each pill can map a tone to
// its own colours without duplicating the status lists.
export function groupStatusTone(status) {
  const key = normalise(status)
  if (POSITIVE.indexOf(key) !== -1) {
    return 'positive'
  }
  if (NEGATIVE.indexOf(key) !== -1) {
    return 'negative'
  }
  return 'neutral'
}
